module.exports = __webpack_public_path__ + "static/dct-stars-77571615329fa99ed4d05fabc400f417.png";